import axios from 'axios'

import { router } from '../router'
import { API_ENDPOINT } from '../config'

import { Message } from 'view-design'

// axios 配置
axios.defaults.timeout = 360000
axios.defaults.baseURL = API_ENDPOINT

// http request 拦截器
// axios.interceptors.request.use(
// config => {
//   if (Auth.authenticated()) {
//   }
//   return config
// },
// err => {
//   return Promise.reject(err)
// }
// )

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    const originalRequest = error.config
    if (!originalRequest._retry) {
      if (!error.response) {
        Message.error(error.message)
        return new Promise(() => {})
      }

      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          router.replace({
            path: 'login',
            query: { redirect: router.currentRoute.fullPath }
          })
          return new Promise(() => {})
        case 403:
          // 403 没有权限
          Message.error('没有权限')
          return new Promise(() => {})
        case 404:
          // 404 请求资源不存在
          Message.error('请求资源不存在')
          return new Promise(() => {})
        case 405:
          // 404 请求资源不存在
          Message.error(error.response.data.message)
          return new Promise(() => {})
        case 422:
          Message.error(error.response.data.message)
          return new Promise(() => {})
        case 500:
          // 500 服务器错误
          Message.error('服务器错误，请联系管理员')
          break
      }
    }
    return Promise.reject(error)
  })

export default axios
